module.exports = __webpack_public_path__ + "static/img/index_banner_icon.44015366.png";